import Form from './Form';

export default Form;



// WEBPACK FOOTER //
// ./src/components/FormGenerator/Form/index.tsx